<div class="relative flex items-center justify-center">
  @if (!isLoading) {
    <span class="typo-h4-medium absolute left-0">{{ 'patientSearch_result' | translate: { input1: totalCount } }}</span>
  }

  <lib-input
    class="max-w-[590px] flex-1 justify-self-center sm:max-w-[900px] lg:max-w-[1220px]"
    [formControl]="searchControl"
    [placeholder]="'patientSearch_hint' | translate"
    background="white"
    [autofocus]="true"
    (valueChange)="closeRecentPatientsDropdown()"
    (inputFocus)="openRecentPatientsDropdown()"
    cdkOverlayOrigin
    #recentPatientsOverlay="cdkOverlayOrigin"
  >
    <svg-icon key="px-24-search" class="text-text-tertiary" leftIcon></svg-icon>
    @if (searchTermSignal() && searchTermSignal()!.length > 0) {
      <button
        class="inline-grid place-items-center rounded-full bg-background-disabled p-1"
        rightIcon
        type="button"
        (click)="clearSearchInput()"
      >
        <svg-icon class="text-text-light" key="px-16-x" size="sm"></svg-icon>
      </button>
    }
  </lib-input>
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayOrigin]="recentPatientsOverlay"
  [cdkConnectedOverlayOpen]="recentPatientsDropdownIsOpen()"
  (backdropClick)="closeRecentPatientsDropdown()"
>
  <div
    class="flex max-h-[270px] w-[590px] flex-col rounded-3xl border-2 border-text-white bg-background-white/40 p-4 shadow-modal backdrop-blur-modal sm:w-[900px] lg:w-[1220px]"
  >
    <span class="mb-2 text-h7 font-light text-text-secondary">{{ 'recent_patient_recent' | translate }}</span>
    <div class="overflow-y-auto">
      @for (patient of recentPatients(); track $index) {
        <button
          class="mb-3 flex w-full items-center gap-3"
          type="button"
          [routerLink]="[patient.patientId]"
          (click)="closeRecentPatientsDropdown()"
          [ffdPushTagOnClick]="{
            event: TagEvent.ChartingOpened,
            location: 'recent_patients',
            patient_id: patient.patientId
          }"
        >
          <lib-avatars [persons]="[patient]" [size]="32"></lib-avatars>
          <span class="typo-h4-light block text-text-primary">{{ patient.firstName }} {{ patient.lastName }}</span>
          <svg-icon class="ml-auto mr-2 text-primary-blue" key="px-16-arrow-right" size="sm"></svg-icon>
        </button>
      }
    </div>
  </div>
</ng-template>
